import { DefaultFetchError, FetchGet, useFetchGet } from "../fetch";

export interface LocationState {
  state: string;
  state_code: string;
  timezone?: string;
  cities: string[];
}

export interface LocationCountry {
  country: string;
  iso2: string;
  timezone?: string;
  states: LocationState[];
}

export const useLocationsDictionary = (): FetchGet<
  LocationCountry[],
  undefined,
  DefaultFetchError
> => useFetchGet("locations/dictionary", { startStateLoading: false });

export default {
  useLocationsDictionary,
};
